// extracted by mini-css-extract-plugin
module.exports = {"elementContainer":"styles_elementContainer__Cyj_v"};